import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Plus } from 'lucide-react';
import ProjectForm from '../../components/ProjectForm';

export default function CreateProject() {
  const navigate = useNavigate();

  const handleProjectCreated = (createdProject?: any) => {
    if (createdProject) {
      // Navigate directly to project asset management for the newly created project
      const projectId = createdProject._id || createdProject.id;
      navigate(`/projects/projectManagment?selectedProject=${projectId}&showAssetEquipment=true`);
    } else {
      // Fallback: Navigate back to projects list
      navigate('/projects/projectManagment');
    }
  };

  const handleBack = () => {
    navigate('/projects/projectManagment');
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25 }}
      className="min-h-screen bg-slate-50/80 font-[family-name:var(--font-outfit)]"
    >
      {/* Compact header */}
      <div className="bg-white border-b border-slate-200 sticky top-0 z-10">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="flex items-center justify-between h-14">
            <div className="flex items-center gap-3">
              <button
                onClick={handleBack}
                className="flex items-center gap-1.5 px-2.5 py-1.5 text-slate-600 hover:text-slate-900 hover:bg-slate-100 rounded-lg transition-colors text-sm font-medium"
              >
                <ArrowLeft size={18} />
                <span className="hidden sm:inline">Back</span>
              </button>
              <div className="h-4 w-px bg-slate-200 hidden sm:block" />
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-teal-100 flex items-center justify-center">
                  <Plus size={16} className="text-teal-600" />
                </div>
                <div>
                  <h1 className="text-base font-semibold text-slate-900">Create project</h1>
                  <p className="text-xs text-slate-500 hidden sm:block">
                    Classic form · Details → Team → Location → Review
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-5">
        <div className="bg-white rounded-xl shadow-sm border border-slate-200">
          <div className="p-4 sm:p-6">
            <ProjectForm onCreated={handleProjectCreated} />
          </div>
        </div>
      </div>
    </motion.div>
  );
}
